export type SellForm = {
  maxPrice: number;
  minPrice: number;
};

export const initialState: SellForm = {
  maxPrice: 0,
  minPrice: 0,
};
